var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscordOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.448 11.8231C8.05206 11.8231 8.54175 11.2518 8.54175 10.547C8.54175 9.8423 8.05206 9.271 7.448 9.271C6.84394 9.271 6.35425 9.8423 6.35425 10.547C6.35425 11.2518 6.84394 11.8231 7.448 11.8231Z",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.552 11.8231C13.1561 11.8231 13.6458 11.2518 13.6458 10.547C13.6458 9.8423 13.1561 9.271 12.552 9.271C11.9479 9.271 11.4583 9.8423 11.4583 10.547C11.4583 11.2518 11.9479 11.8231 12.552 11.8231Z",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17708 5.26025C8.17708 5.26025 8.96429 4.89567 10 4.89567C11.0357 4.89567 11.8229 5.26025 11.8229 5.26025L12.1875 4.1665C13.4675 4.1665 14.419 4.38031 15.4688 4.89567C16.1979 6.11095 17.6563 9.56234 17.6563 13.6457C16.297 15.0487 15.2473 15.6406 13.6458 15.8332L12.5521 14.0103C12.1875 14.1318 11.1667 14.3748 10 14.3748C8.83333 14.3748 7.8125 14.1318 7.44792 14.0103L6.35417 15.8332C4.75271 15.6406 3.70302 15.0487 2.34375 13.6457C2.34375 9.56234 3.80208 6.11095 4.53125 4.89567C5.58094 4.38031 6.53251 4.1665 7.8125 4.1665L8.17708 5.26025Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44784 14.0104C6.65578 13.8081 5.9895 13.2812 5.9895 13.2812",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5522 14.0104C13.3443 13.8081 14.0106 13.2812 14.0106 13.2812",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscordOutlined);
export default __webpack_public_path__ + "static/media/discord-outlined.31e6934545b9e21efbd1062b85a85208.svg";
export { ForwardRef as ReactComponent };